import Cookies from 'js-cookie'
import { BrowserTracing } from '@sentry/tracing'
import { fetchSuggesttionSentry } from '../api/user'

const SENTRY_MAJOR_CUSTOMER = 'SENTRY_MAJOR_CUSTOMER';
const PUBLIC_KEY = '64261e720248420ea3e3b5a4bf32b1cc'
const PROJECT_ID = 2
const SENTRYMAP = {
  crm_shell: {
    key: '64261e720248420ea3e3b5a4bf32b1cc',
    id: 2,
  },
  mail: {
    key: '0665db6412494115af64a460c56adcd7',
    id: 3,
  },
  dx: {
    key: 'd396b68faaa24735ba7a9a3251d0d4fb',
    id: 4,
  },
  mk: {
    key: '28fa92405b6c431f888f1fff42a16a83',
    id: 5,
  },
  valar: {
    key: 'a690a6dbb7f7407c9367ba7c9d96c192',
    id: 6,
  },
  tms: {
    key: 'f1840840d2194849a0ccc12b6f0721a0',
    id: 7,
  },
  sales: {
    key: '8a232242dd0742d3adebffdb4f2a11a7',
    id: 8,
  },
  crm: {
    key: 'c3f021c1bce7492f8fac36d13ab2faa6',
    id: 9,
  },
  'common-qiankun': {
    key: '6833ce93faa949fca5e44106844bed11',
    id: 10,
  },
  leads: {
    key: '89e963b5a3fc4d37a276b48364b7f918',
    id: 23,
  },
  new_discovery: {
    key: '8b6c3430435847268bb39520ffd98aee',
    id: 24,
  },
  talk: {
    key: 'fe664cf0fe64436a8dc1ae63be41d2be',
    id: 25,
  },
} as { [key: string]: any }

const getSuggestionSentry = () => {
  const suggestionStatus = Cookies && Cookies.get(SENTRY_MAJOR_CUSTOMER)
  let tracesSampleRate = 0.1
  if (!suggestionStatus) {
    fetchSuggesttionSentry()
      .then((res: { data: string }) => {
        if (res) {
          Cookies &&
            Cookies.set(SENTRY_MAJOR_CUSTOMER, res.data, {
              expires: 7,
            })
        }
      })
      .catch(() => {
        console.error('catch fetchSuggesttionSentry')
      })
  } else if (/\/crm\/customer\/list/.test(location.pathname)) {
    tracesSampleRate = 0.2
  } else if (suggestionStatus === 'true') {
    tracesSampleRate = 0.8
  }
  return tracesSampleRate
}

export const initSentry = (project: string, release: string) => {
  if (!project || !window.Sentry) return
  const { Sentry } = window
  let key = SENTRYMAP[project] ? SENTRYMAP[project].key : PUBLIC_KEY
  let id = SENTRYMAP[project] ? SENTRYMAP[project].id : PROJECT_ID
  const environment = window.__app_env__.IS_GREY ? 'grey' : window.__app_env__.RUNTIME_ENV
  const options = {
    dsn: `https://${key}@sen.xiaoman.cn/${id}`,
    sampleRate: 0.8,
    environment,
    defaultIntegrations: false,
    ignoreErrors: [
      'custom exception',
      'Network Error',
      'Non-Error exception captured',
      'Failed to fetch',
      'timeout',
      'Non-Error promise rejection captured',
      'layer.css',
      'the tour is had',
      'code.css',
      'laydate.css',
    ],
    integrations: [
      new Sentry.Integrations.InboundFilters(),
      new Sentry.Integrations.FunctionToString(),
      new Sentry.Integrations.TryCatch(),
      new Sentry.Integrations.Breadcrumbs({
        console: false,
      }),
      new Sentry.Integrations.GlobalHandlers({
        onunhandledrejection: false,
        onerror: true,
      }),
      new Sentry.Integrations.LinkedErrors(),
      new Sentry.Integrations.UserAgent(),
      new BrowserTracing(),
    ],
    tracesSampleRate: getSuggestionSentry(),
    beforeBreadcrumb: (breadcrumb: { category: string }, hint: { xhr: any }) => {
      if (breadcrumb.category === 'xhr') {
        const { xhr } = hint
        const data = {
          ...xhr.__sentry_xhr__,
          // 钞能力有限
          response: xhr.response.substring(0, 200),
        }
        return { ...breadcrumb, data }
      }
      return breadcrumb
    },
    beforeSend: (event: { breadcrumbs: string | any[]; release: any }, hint: { originalException: { stack: any } }) => {
      // 仅保留最后两次请求的response 避免上报实体过大
      let lastEvent = 0
      // 会存在无面包屑情况的错误
      if (event?.breadcrumbs?.length) {
        for (let i = event.breadcrumbs.length - 1; i >= 0; i--) {
          if (event.breadcrumbs[i]?.category === 'xhr') {
            lastEvent++
            if (lastEvent > 2 && event.breadcrumbs[i].data) {
              delete event.breadcrumbs[i].data.response
            }
          }
        }
      }
      return event
    },
  } as any
  if (release) options.release = release

  if (project !== 'crm_shell') {
    // TODO hub无法采集web vitals https://github.com/getsentry/sentry-javascript/issues/4772
    const client = new Sentry.BrowserClient(options)
    const hub = new Sentry.Hub(client)
    hub.run(
      (currentHub: { withScope: (arg0: () => void) => void; startSession: () => void; captureSession: () => void }) => {
        currentHub.withScope(() => {
          currentHub.startSession()
          currentHub.captureSession()
        })
      },
    )
    Sentry.makeMain(hub)
  } else {
    // only crm_shell init
    Sentry.init(options)
  }

  Sentry.configureScope(function (scope: {
    setUser: (arg0: { id: string | undefined; username: string | undefined; email: string | undefined }) => void
  }) {
    scope.setUser({
      id: Cookies.get('userId'),
      username: Cookies.get('clientId'),
      email: Cookies.get('account'),
    })
  })
}
